import React from "react"
import { Flex, Heading, Box } from "@chakra-ui/react"
import { useShopifyPrice } from "@app/hooks/useShopify"
import { useBundle } from "@app/hooks/useBundle"
import { ProductVariant } from "@shopify/hydrogen-react/storefront-api-types"

type Props = {
  product: any
  activeVariant: ProductVariant | null
}

const ProductTitle: React.FC<Props> = ({ product, activeVariant }) => {
  const { formattedPrice, onSale, formattedCompareAtPrice } = useShopifyPrice(activeVariant, 1)

  const { isBundle, isOnSale, bundlePriceDiscounted, bundlePriceFull } = useBundle(product)
  return (
    <Flex flexFlow={{ base: "column", md: "row" }} justify="space-between" gap={4}>
      <Heading as="h1" fontSize={{ base: "24px", md: "32px" }} lineHeight={1.25} fontWeight={700}>
        {product?.title}
      </Heading>

      <Heading fontSize={{ base: "24px", md: "32px" }} lineHeight={1.25} fontWeight={700}>
        {!isBundle ? (
          <>
            {onSale && (
              <Box as="span" pr="5px" textDecoration="line-through">
                {formattedCompareAtPrice}
              </Box>
            )}
            <Box as="span" color={onSale ? "brand.red" : "inherit"}>
              {formattedPrice}
            </Box>
          </>
        ) : (
          <>
            <Box as="span" textDecoration={isOnSale ? "line-through" : "none"}>
              {bundlePriceFull}
            </Box>
            {isOnSale && (
              <Box as="span" pl="5px" color="red">
                {bundlePriceDiscounted}
              </Box>
            )}
          </>
        )}
      </Heading>
    </Flex>
  )
}

export default React.memo(ProductTitle)
